var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 2.5V37.5H2.5V2.5H37.5ZM5 5V25H7.92969L10.0586 22.8711C10.306 22.6237 10.599 22.5 10.9375 22.5C11.276 22.5 11.569 22.6237 11.8164 22.8711L15.2734 26.3086L20.0391 7.8125C20.1042 7.53906 20.2474 7.31771 20.4688 7.14844C20.6901 6.97917 20.9505 6.88802 21.25 6.875C21.5495 6.875 21.8099 6.95964 22.0312 7.12891C22.2526 7.29818 22.3958 7.53255 22.4609 7.83203L24.4531 15.9766H27.5C27.7865 15.9766 28.0404 16.0612 28.2617 16.2305C28.4831 16.3997 28.6328 16.6276 28.7109 16.9141L30.1172 22.5H35V5H5ZM35 35V25H29.1406C28.8411 25 28.5807 24.9154 28.3594 24.7461C28.138 24.5768 27.9948 24.3424 27.9297 24.043L26.5234 18.4766H23.4766C23.1771 18.4766 22.9167 18.3919 22.6953 18.2227C22.474 18.0534 22.3307 17.819 22.2656 17.5195L21.2109 13.2617L17.1484 29.0625C17.0833 29.3359 16.9401 29.5573 16.7188 29.7266C16.4974 29.8958 16.237 29.987 15.9375 30C15.599 30 15.306 29.8763 15.0586 29.6289L10.9375 25.5078L9.31641 27.1289C9.06901 27.3763 8.77604 27.5 8.4375 27.5H5V35H35Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature_2.06a73d6cad51800c918ba1237341169b.svg";
export { ForwardRef as ReactComponent };